<ng-container *ngIf="appearance=='legacy'">

    <button class="trigger-btn" (click)="toggleTrigger($event)" type="button" #btnRef cdkOverlayOrigin
        #trigger="cdkOverlayOrigin">
        <div #btnLabelRef class="btn-row">
            <div class="label">{{customLabel || label}}</div>
            <mat-icon #btnIconRef>expand_more</mat-icon>
        </div>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen"
        (overlayOutsideClick)="menuClickOutside($event)">

        <div class="bubble">
            <div class="select-inner">
                <div class="font-semibold text-csm text-custom-black mb-2">
                    {{label}}
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <button class="adc-btn" [class.active]="value.selected" *ngFor="let value of selectList"
                        (click)="toggleSelectValue(value._id, value,control)">
                        <span class="text">{{ translateHelper.localize(value?.name) }}</span>
                    </button>
                </div>

                <div *ngIf="combineLabel && combineControl" class="font-semibold text-csm text-custom-black mt-4 mb-2">
                    {{combineLabel}}
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <button class="adc-btn" [class.active]="value.selected" *ngFor="let value of combineSelectList"
                        (click)="toggleSelectValue(value._id, value,combineControl)">
                        <span class="text">{{ translateHelper.localize(value?.name) }}</span>
                    </button>
                </div>
            </div>



        </div>
    </ng-template>
</ng-container>


<ng-container *ngIf="appearance=='filter'">

    <div class="widget-filters__list">
        <div class="widget-filters__item">
            <div class="filter filter--opened" appCollapseItem="filter--opened" #collapse="appCollapseItem">

                <button type="button" class="filter__title" (click)="collapse.toggle()">
                    <span class="me-2">•</span> {{customLabel || label}}
                    <!--   <img src="assets/svg/filters/collapse_arrow.svg" class="collapse-arrow"> -->
                </button>
                <div class="filter__body" appCollapseContent>
                    <div class="filter__container">

                        <div class="filter-list">
                            <div class="filter-list__list">
                                <div class="select-inner">
                                    @if(combineControl){
                                    <div class="font-semibold text-csm text-custom-black mb-2">
                                        {{label}}
                                    </div> }
                                    <div class="flex flex-row flex-wrap gap-2 items-center">
                                        <button [disabled]="value?.count === 0" [ngClass]="{
                                            'bg-[#f2f2f2] text-[#808080]' : value?.count === 0,
                                            'bg-blue-default':value?.count !== 0 && value.selected,
                                            'bg-blue-default/40':value?.count !== 0 && !value.selected,
                                            'text-white' : value?.count !== 0
                                        }" class="adc-btn " *ngFor="let value of selectList"
                                            (click)="toggleSelectValue(value._id, value,control)">
                                            <span class="text">{{ translateHelper.localize(value?.name) }}</span>
                                        </button>
                                    </div>

                                    <div *ngIf="combineLabel && combineControl"
                                        class="font-semibold text-csm text-custom-black mt-4 mb-2">
                                        {{combineLabel}}
                                    </div>
                                    <div class="flex flex-row flex-wrap gap-2 items-center">
                                        <button
                                            class="adc-btn text-white {{value.selected?'bg-blue-default':'bg-blue-default/10'}}"
                                            *ngFor="let value of combineSelectList"
                                            (click)="toggleSelectValue(value._id, value,combineControl)">
                                            <span class="text">{{ translateHelper.localize(value?.name) }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>